<script>
import Layout from '@layouts/main.vue'
import TheSettingsContainer from '@/components/settings/the-settings-container.vue'

export default {
  metaInfo: {
    title: 'Settings',
    meta: [{ name: 'description', content: 'The Settings page.' }],
  },
  components: { Layout, TheSettingsContainer },
}
</script>

<template>
  <Layout>
    <v-row class="d-flex justify-center">
      <v-col cols="12" md="12" lg="8" xl="5">
        <BasePageTitle :title="$t('settings.pageTitle')" />
        <TheSettingsContainer />
      </v-col>
    </v-row>
  </Layout>
</template>
